<template lang='pug'>
.binding-container()
    userCard
    .title  1688绑定
    .img-box
        .img-container
            img(v-src="'https://oss.cloud.custouch.com/res/22288/敬请期待.png'")   
        .text 敬请期待            
</template>

<script>
import userCard from './components/userCard'
export default {
    name:'binding',
    data(){
        return {
            
        }
    },
    components:{
       userCard
    },
    async created() {
        this.$root.$emit('action',{name:this.$route.name})
    },
    computed:{
    },
    methods:{
       
        
    }
}
</script>

<style scoped lang='less'>
.title{
    line-height: 0.9rem;
    color:#07448a;
    height: 0.9rem;
    margin-left:1rem;
    margin-top:1rem;
    font-weight: 700;
}
.img-box{
     width:4.7rem;
    margin:0 auto;
    margin-top:4.4rem;
    .img-container{
        width:100%;
        height:3.9rem;
        img{
            display: block;
            object-fit: cover;
            width:100%;
            height: 100%;
        }
    }
    .text{
        height: 0.85rem;
        line-height: 0.85rem;
        font-size: 0.6rem;
        color: #646464;
        text-align: center;
        margin-top:0.6rem
    }
}
</style>